export default __webpack_public_path__ + "static/media/pump-001.55a006e2.png";